import React, {Fragment} from 'react';

import {Props} from '../Builder/ElementProperties';

const ClickAreaElement = (props) => {


	let onClick = Props.onClickAreaHandler.bind(this, {props, elementType:'clickarea'});


	return (
		<div
			className={'ClickAreaElement'}
			style={{height: '100%', width:'100%'}}
			onClick = {onClick}
			tabIndex='1'
			>
			{props.builder && props.element.id}
		</div>
	);
}

const Properties = (props) => (
	<Fragment>
		<Props.Id {...props} />
		<Props.X {...props} />
		<Props.Y {...props} />
		<Props.Width {...props} />
		<Props.Height {...props} />
		<Props.OnClick {...props} />
	</Fragment>
);

ClickAreaElement.type = 'clickarea';
ClickAreaElement.Properties = Properties;
ClickAreaElement.defaultJSON = {type: 'clickarea', id:'New Click Area', x: 250, y:250, width:100, height:50,  onClick:'{next}'};
export default ClickAreaElement;


// WEBPACK FOOTER //
// ./src/components/ScreenElements/ClickAreaElement.js